<template>
  <section class="online-scheduling">
    <div class="site-container site-section-v">
      <form-scheduling origem='CRIVELLI'>
        <template #form-top>
          <h2 class="text-orange" style="margin-bottom: 3rem">
            Agendamento Online
          </h2>
          <p>
            Agende um atendimento telepresencial com um de nossos advogados de forma rápida e escolhendo você mesmo o melhor horário para falar conosco. Insira suas informações, selecione o dia e horário do atendimento, receba o link para acesso à reunião virtual e é só aguardar. 
          </p>
          <p>
            Crivelli Advogados Associados conta com especialistas em direito do trabalho, previdenciário, civil, sindical e direito médico. Antes de agendar seu atendimento on-line verifique, por gentileza, se sua demanda se encaixa em uma de nossas áreas de atuação.
          </p>
        </template>
      </form-scheduling>
      <hr />

      <download-app />
    </div>
  </section>
</template>

<script>
import FormScheduling from "@/components/FormScheduling";
import DownloadApp from "@/components/Home/DownloadApp";

export default {
  components: { DownloadApp, FormScheduling },
};
</script>

<style>
</style>
